var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.mnemonic,
          expression: "mnemonic"
        }
      ],
      staticClass: "mnemonic"
    },
    [
      _c("div", { staticClass: "row" }, [
        _c("span", { staticClass: "small-title" }, [
          _vm._v(_vm._s(_vm.$t("mnemonic.title")))
        ]),
        _vm._v(" "),
        _c("span", {
          staticClass: "copy icon __pointer",
          class: { lock: _vm.lock },
          on: { click: _vm.copy }
        }),
        _vm._v(" "),
        _c("span", {
          staticClass: "lock-icon icon __pointer",
          class: {
            lock: _vm.lock
          },
          on: { click: _vm.unlock }
        })
      ]),
      _vm._v(" "),
      _c("copy", { ref: "copyDome", staticClass: "copy-wrapper" }),
      _vm._v(" "),
      _c("div", { staticClass: "content" }, [_vm._v(_vm._s(_vm.mnemonicStr))])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }